module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-four-a.a8972a81.png";